import { render } from "./BecomeCreatorContent.vue?vue&type=template&id=37a78302"
import script from "./BecomeCreatorContent.vue?vue&type=script&lang=js"
export * from "./BecomeCreatorContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__